import AsyncStorage from "@react-native-async-storage/async-storage";
// import * as SecureStore from 'expo-secure-store';
import ENV from "app/utils/ENV";

let storageActions = {
  async saveItem(item, selectedValue) {
    // if(!ENV.WEB) selectedValue = ""
    try {
      if (typeof selectedValue == "string") {
      }
      selectedValue = JSON.stringify(selectedValue);
      await AsyncStorage.setItem(item, selectedValue);
    } catch (error) {
      console.warn("AsyncStorage error: " + error.message);
    }
  },
  async fetchItem(item, fallback = undefined) {
    // if(!ENV.WEB) item = ""
    try {
      let value = await AsyncStorage.getItem(item);
      if (!!value || value === false || value == "false") {
        value = JSON.parse(value);
        return value;
      } else {
        return fallback;
      }
    } catch (error) {
      console.warn(error);
    }
  },
  async clearItem(item) {
    try {
      await AsyncStorage.removeItem(item);
    } catch (error) {
      console.warn("AsyncStorage error: " + error.message);
    }
  },
  async clearAll(preserveBiometrics = false) {
    // console.log(`preserve Bio: ${preserveBiometrics}`)
    try {
      // let biometricSettings = null
      // if(preserveBiometrics){
      //   biometricSettings = await storageActions.fetchItem('biometricSettings', true)
      // }
      // else {
      //   // biometricHelpers.clearSensitiveBiometricData()
      //   await SecureStore.deleteItemAsync('email', {})
      //   await SecureStore.deleteItemAsync('password', {})
      // }
      // let debugData = await storageActions.fetchItem('debugData', true)

      await AsyncStorage.clear();

      // if(preserveBiometrics && biometricSettings){
      //   await storageActions.saveItem('biometricSettings', JSON.stringify(biometricSettings))
      // }
      // if(!!debugData){
      //   await storageActions.saveItem('debugData', JSON.stringify(debugData))
      // }
    } catch (error) {
      console.warn("AsyncStorage error: " + error.message);
    }
  },
};

export default storageActions;
